<template>
  <div>
    <b-card no-body>
      <b-row class="mx-1 mt-2 mb-1" align-h="between">
        <b-col lg="7" md="12" sm="12">
          <b-row align-h="between">
            <b-col lg="4" md="4" sm="12" class="mb-1">
              <div class="form-select">
                Show
                <b-form-select
                  v-model="perPage"
                  :options="options"
                  style="width: 60px;"
                  size="sm"
                ></b-form-select>
                Entries
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="5" md="12" sm="12" class="mb-1">
          <b-row align-h="end">
            <SearchBar>
              <template #input>
                <b-form-input v-model="filter" type="search" placeholder="Search" />
              </template>
            </SearchBar>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div v-if="hasData">
            <b-table
              class="table-with-actions-min-height px-2"
              responsive
              striped
              outlined
              :items="devicesFilter"
              :fields="computedTableFields"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              @filtered="onFiltered"
              select-mode="single"
              @row-clicked="handleRowClick"
              selectable
            >
              <template #cell(usersCount)="row">
                {{ formatNumberWithCommas(row.value) }}
              </template>
              <template #cell(programsCount)="row">
                {{ formatNumberWithCommas(row.value) }}
              </template>
              <template #cell(totalProgramsExecCount)="row">
                {{ formatNumberWithCommas(row.value) }}
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="paginationTotalRows"
              :per-page="perPage"
              align="right"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-2 mx-1"
            />
          </div>
          <div v-else class="mx-1 pl-1 mb-1">
            {{ $t("No Data Available") }}
          </div>
        </b-col>
      </b-row>
    </b-card>
    <DeviceDetails
      v-if="isRowSelected"
      :timeRange="timeRange"
      :rowInfo="selectedRowInfo"
    />
  </div>
</template>

<script>
import DeviceDetails from '@/xvisor/components/security/DeviceDetails.vue';
import SearchBar from '@/xvisor/components/SearchBar.vue';
import collapseText from '@/xvisor/utilities/collapseText';
import hostnameFormatter from '@/xvisor/utilities/hostnameFormatter';
import formatNumberWithCommas from '@/xvisor/utilities/addCommaToNumber';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  components: {
    DeviceDetails,
    SearchBar,
  },
  data() {
    return {
      devicesInfo: [],
      currentPage: 1,
      perPage: 10,
      options: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 15, text: '15' },
      ],
      filter: null,
      filteredLength: null,
      tableFields: [
        { key: 'hostName', label: 'Host Name', sortable: true },
        { key: 'osType', label: 'OS Type', sortable: true },
        { key: 'usersCount', label: 'Users', sortable: true },
        { key: 'programsCount', label: 'Processes', sortable: true },
        { key: 'totalProgramsExecCount', label: 'Count', sortable: true },
      ],
      selectedRow: null,
    };
  },
  computed: {
    hasData() {
      return this.devicesInfo && this.devicesInfo.length > 0;
    },
    paginationTotalRows() {
      if (this.filter) return this.filteredLength;
      return this.devicesInfo.length;
    },
    computedTableFields() {
      return this.tableFields;
    },
    devicesFilter() {
      const retVal = this.devicesInfo;
      return retVal;
    },
    isRowSelected() {
      return this.selectedRow !== null && this.selectedRow.data !== null;
    },
    selectedRowInfo() {
      return this.selectedRow.data;
    },
  },
  watch: {
    url() {
      this.httpGet();
    },
    timeRange() {
      this.httpGet();
    },
    devicesInfo() {
      this.filteredLength = this.devicesFilter.length;
    },
  },
  mounted() {
    this.httpGet();
  },
  methods: {
    httpGet() {
      this.loaded = false;
      this.selectedRow = null;
      this.$http
        .get(this.url, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
          },
        })
        .then((response) => { this.devicesInfo = response.data; })
        .finally(() => { this.loaded = true; });
    },
    onFiltered(filteredItems) {
      this.filteredLength = filteredItems.length;
      this.currentPage = 1;
    },
    handleRowClick(row, idx) {
      if (this.isRowSelected && this.selectedRow.rowIdx === idx) {
        this.selectedRow = null;
        return;
      }
      this.selectedRow = {
        data: row,
        rowIdx: idx,
      };
    },
    collapseText,
    hostnameFormatter,
    formatNumberWithCommas,
  },
};
</script>

<style scoped>
.form-select{
  min-width: 160px;
  width: 20%;
}
</style>
